import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-apollo";
import { Field, Control, Column, Label, Input } from "rbx";
import { useCompanyParameters } from "../../../utils/hooks";
import {
  CompanyLocationSelect,
  ItemCategorySelect,
  InventoryStorageDimSelect,
  BooleanInput
} from "../../../components/inputs";

import FilterButtons from "../../../components/FilterButtons";
import { SINGLE_ITEM_QUERY } from "../../../graphql/Items/Items.graphql";
import { SINGLE_INVENTORY_STORAGE_DIM_QUERY } from "../../../graphql/InventoryStorageDims/InventoryStorageDims.graphql";

const DEFAULT_FILTERS = {
  ItemActive: true
};
function InventoryOnHandFilters({ filters, onFilter, onClose }) {
  const [inputs, setInputs] = useState({
    ...filters
  });
  const { data: params } = useCompanyParameters();

  const ItemData = useQuery(SINGLE_ITEM_QUERY, {
    variables: {
      where: {
        RecId:
          typeof inputs.ItemRecIdRef === "number" ? inputs.ItemRecIdRef : null
      }
    }
  });

  const PrimaryStorageDim = useQuery(SINGLE_INVENTORY_STORAGE_DIM_QUERY, {
    variables: {
      where: {
        RecId:
          typeof inputs.InvDim1RecIdRef === "number"
            ? inputs.InvDim1RecIdRef
            : null
      }
    }
  });

  const SecondaryStorageDim = useQuery(SINGLE_INVENTORY_STORAGE_DIM_QUERY, {
    variables: {
      where: {
        RecId:
          typeof inputs.InvDim2RecIdRef === "number"
            ? inputs.InvDim2RecIdRef
            : null
      }
    }
  });

  const TertiaryStorageDim = useQuery(SINGLE_INVENTORY_STORAGE_DIM_QUERY, {
    variables: {
      where: {
        RecId:
          typeof inputs.InvDim3RecIdRef === "number"
            ? inputs.InvDim3RecIdRef
            : null
      }
    }
  });
  const handleChange = e => {
    const updates = { ...inputs };
    if (e.value && !e.target && e.name) {
      updates[e.name] = {
        ...e,
        label: e.label.replace(`- ${e.otherLabel}`, "")
      };
      if (e.name === "ItemDescriptionRecIdRef") {
        updates.ItemRecIdRef = {
          ...e,
          label: e.otherLabel
        };
      } else if (e.name === "ItemRecIdRef") {
        updates.ItemDescriptionRecIdRef = {
          ...e,
          label: e.otherLabel
        };
      }
    } else {
      const value =
        e.target.type === "checkbox" ? e.target.checked : e.target.value;
      updates[e.target.name] =
        e.target.name === "CompanyLocRecIdRef" ||
        e.target.name === "ItemCatgRecIdRef"
          ? parseInt(value)
          : value;
    }
    setInputs(prev => ({ ...prev, ...updates }));
  };

  useEffect(() => {
    if (
      inputs &&
      inputs.ItemRecIdRef &&
      typeof inputs.ItemRecIdRef === "number" &&
      ItemData.data &&
      ItemData.data.Item &&
      !ItemData.loading
    ) {
      const updates = { ...inputs };
      updates.ItemRecIdRef = {
        value: ItemData.data.Item.RecId,
        name: "ItemRecIdRef",
        label: `${ItemData.data.Item.ItemNo} - ${ItemData.data.Item.Description}`
      };
      updates.ItemDescriptionRecIdRef = {
        value: ItemData.data.Item.RecId,
        name: "ItemDescriptionRecIdRef",
        label: `${ItemData.data.Item.Description} - ${ItemData.data.Item.ItemNo}`
      };
      setInputs({ ...updates });
    }
    if (
      inputs &&
      inputs.InvDim1RecIdRef &&
      typeof inputs.InvDim1RecIdRef === "number" &&
      PrimaryStorageDim.data &&
      PrimaryStorageDim.data.InventoryStorageDim &&
      !PrimaryStorageDim.loading
    ) {
      const updates = { ...inputs };
      updates.InvDim1RecIdRef = {
        value: PrimaryStorageDim.data.InventoryStorageDim.RecId,
        label: PrimaryStorageDim.data.InventoryStorageDim.DimCode
      };
      setInputs({ ...updates });
    }
    if (
      inputs &&
      inputs.InvDim2RecIdRef &&
      typeof inputs.InvDim2RecIdRef === "number" &&
      SecondaryStorageDim.data &&
      SecondaryStorageDim.data.InventoryStorageDim &&
      !SecondaryStorageDim.loading
    ) {
      const updates = { ...inputs };
      updates.InvDim2RecIdRef = {
        value: SecondaryStorageDim.data.InventoryStorageDim.RecId,
        label: SecondaryStorageDim.data.InventoryStorageDim.DimCode
      };
      setInputs({ ...updates });
    }
    if (
      inputs &&
      inputs.InvDim3RecIdRef &&
      typeof inputs.InvDim3RecIdRef === "number" &&
      TertiaryStorageDim.data &&
      TertiaryStorageDim.data.InventoryStorageDim &&
      !TertiaryStorageDim.loading
    ) {
      const updates = { ...inputs };
      updates.InvDim3RecIdRef = {
        value: TertiaryStorageDim.data.InventoryStorageDim.RecId,
        label: TertiaryStorageDim.data.InventoryStorageDim.DimCode
      };
      setInputs({ ...updates });
    }
  }, [
    inputs,
    ItemData.data,
    ItemData.loading,
    PrimaryStorageDim.data,
    PrimaryStorageDim.loading,
    SecondaryStorageDim.data,
    SecondaryStorageDim.loading,
    TertiaryStorageDim.data,
    TertiaryStorageDim.loading
  ]);

  const handleClose = () => onClose(onFilter(inputs));

  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () => onClose(onFilter({ ...DEFAULT_FILTERS }));

  console.log({ params });
  return (
    <div style={{ width: 800, maxWidth: "90vw" }}>
      <Column.Group>
        <Column size={6}>
          <Control expanded>
            <ItemCategorySelect
              icon="globe"
              label="Item Category"
              name="ItemCatgRecIdRef"
              value={inputs.ItemCatgRecIdRef}
              onChange={handleChange}
            />
          </Control>
        </Column>
        <Column size={5}>
          <Control>
            <CompanyLocationSelect
              firstOptionEnabled
              icon="globe"
              label="Location"
              name="CompanyLocRecIdRef"
              value={inputs.CompanyLocRecIdRef}
              variables={{ Active: true }}
              onChange={handleChange}
            />
          </Control>
        </Column>
        <Column>
          <Field>
            <Control>
              <Label>Active</Label>
              <BooleanInput
                name="ItemActive"
                value={inputs.ItemActive}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <Column.Group>
        <Column>
          <Field>
            <Control>
              <Label>Item Number</Label>
              <Input
                name="ItemNo_contains"
                type="text"
                value={inputs.ItemNo_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <Label>Item Description</Label>
              <Input
                name="ItemDescription_contains"
                type="text"
                value={inputs.ItemDescription_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <Column.Group>
        {params?.UsePrimaryStorageDimension && (
          <Column>
            <InventoryStorageDimSelect
              CompanyLocRecIdRef={inputs.CompanyLocRecIdRef}
              InvStorageDimRecIdRef={params.PrimaryStorageDimension.RecId}
              icon="globe"
              label={`${params.PrimaryStorageDimension.CodeDescription}`}
              name="InvDim1RecIdRef"
              value={inputs.InvDim1RecIdRef}
              onChange={handleChange}
            />
          </Column>
        )}
        {params?.UseSecondaryStorageDimension && (
          <Column>
            <InventoryStorageDimSelect
              CompanyLocRecIdRef={inputs.CompanyLocRecIdRef}
              InvStorageDimRecIdRef={params.SecondaryStorageDimension.RecId}
              icon="globe"
              label={`${params.SecondaryStorageDimension.CodeDescription}`}
              name="InvDim2RecIdRef"
              value={inputs.InvDim2RecIdRef}
              onChange={handleChange}
            />
          </Column>
        )}
        {params?.UseTertiaryStorageDimension && (
          <Column>
            <InventoryStorageDimSelect
              CompanyLocRecIdRef={inputs.CompanyLocRecIdRef}
              InvStorageDimRecIdRef={params.TertiaryStorageDimension.RecId}
              icon="globe"
              label={`${params.TertiaryStorageDimension.CodeDescription}`}
              name="InvDim3RecIdRef"
              value={inputs.InvDim3RecIdRef}
              onChange={handleChange}
            />
          </Column>
        )}
      </Column.Group>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </div>
  );
}
InventoryOnHandFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};
InventoryOnHandFilters.defaultProps = {
  filters: {}
};
export default InventoryOnHandFilters;
